import { ViewEventMenu } from '../views/eventMenu';

export default function EventMenu() {
    return <ViewEventMenu />
}